import React from 'react'
import * as S from './styles'
import ImageCustom from '../ImageCustom'
import { StrapiCard } from '@shared/utils/strapi/strapi.types'
import { useHome } from '@site/contexts/homeContext'

type PlanSelectorProps = {
  card: StrapiCard
  hasGift: boolean
  hasOriginalPrice: boolean
  key: string
}

const ClubCarouselCard: React.FC<PlanSelectorProps> = ( props ) => {
  const { card, key, hasGift, hasOriginalPrice } = props
  const { isCTABouncing, setIsCTABouncing } = useHome()

  const displayGift = ( card: StrapiCard ) => {
    if ( !hasGift ) {
      return null
    }
    if ( card.gift && card.gift !== '' ) {
      return <S.GiftWrapper>
        <ImageCustom
          image={ card.giftIcon }
          alt={ card.gift }
        />
        <S.GiftText
          textColor={ card.detailsColor }
        >
          { card.gift }
        </S.GiftText>
      </S.GiftWrapper>
    }
    return <S.GiftWrapper />
  }

  const displayOriginalPrice = ( card: StrapiCard ) => {
    if ( !hasOriginalPrice ) {
      return null
    }
    if ( !card.originalPrice || card.originalPrice === '' ) {
      return <S.OriginalPrice textColor={ card.detailsColor } />
    }
    return (
      <S.OriginalPrice
        textColor={ card.detailsColor }
      >
        R${card.originalPrice}
      </S.OriginalPrice>
    )
  }

  return (
    <S.Wrapper key={ key }>
      <S.PlanCard
        className="plan-card"
        backgroundColor={ card.backgroundColor }
      >
        <S.CardHeader
          detailColor={ card.detailsColor }
        />
        <S.CardContentWrapper>
          <S.ImageWrapper>
            <ImageCustom
              image={ card.image }
              alt="club logo"
            />
          </S.ImageWrapper>

          <S.CardText
            className="card-text"
          >
            {card.text}
          </S.CardText>
          <S.PriceWrapper
            className="price-wrapper"
          >
            { displayOriginalPrice( card ) }
            <S.Price
              textColor={ card.detailsColor }
            >
                R${card.price}
              <S.ByMonth>
                /mês
              </S.ByMonth>
            </S.Price>
            <S.ShippingCharge
              textColor={ card.detailsColor }
            >
              <span>+ taxa de entrega</span>
            </S.ShippingCharge>
          </S.PriceWrapper>

          { displayGift( card ) }

          <S.PrimaryCta
            href={ card.primaryCtaLink }
            backgroundColor={ card.detailsColor }
            bounce={ isCTABouncing }
            onAnimationEnd={ () => setIsCTABouncing( false ) }
          >
            { card.primaryCta }
          </S.PrimaryCta>
          { card.secondaryCta && card.secondaryCtaLink && (
            <S.SecondaryCta
              href={ card.secondaryCtaLink }
              backgroundColor={ card.backgroundColor }
              textColor={ card.detailsColor }
            >
              { card.secondaryCta }
            </S.SecondaryCta>
          ) }
        </S.CardContentWrapper>
      </S.PlanCard>
    </S.Wrapper>
  )
}

export default ClubCarouselCard
